import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type AssignCourseResponse = {
    studentId:string;
    courseId:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;
export const AssignCourseToStudent = ({
    studentId,
    courseId
}: {
    studentId: string;
    courseId:string;
}): Promise<AssignCourseResponse> => {
  return axios.put(`/student/assignCourse/${studentId}/${courseId}`);
};
